// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"cu-z","giftOrPromoSelector":"du-z","disabled":"eu-z","subTitle":"fu-z","selectShipAddressMessage":"gu-z","changePayment":"hu-z"};